import type { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";

import classNames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";
import type { LinkBehaviourProps } from "@jti/core-components/components/LinkBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./IconButton.module.scss";

type CommonIconButtonProps = PropsWithChildren<{
  icon?: DirectionalIconComponent;
  iconPosition?: "start" | "end";
}>;
type IconLinkButtonProps = LinkBehaviourProps & CommonIconButtonProps;
type IconHTMLButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & CommonIconButtonProps;
/**
 * @deprecated use IconButtonProps from @jti/ui instead
 */
export type DEPRECATED_IconButtonProps = IconLinkButtonProps | IconHTMLButtonProps;

const isLinkButton = (props: DEPRECATED_IconButtonProps): props is IconLinkButtonProps => {
  return "href" in props;
};

const isButtonElement = (props: DEPRECATED_IconButtonProps): props is IconHTMLButtonProps => {
  return !("href" in props);
};

/**
 * @deprecated replacement component TBD
 */
export const DEPRECATED_IconButton: FC<DEPRECATED_IconButtonProps> = ({
  children,
  className,
  icon: Icon,
  iconPosition = "start",
  ...rest
}) => {
  const classes = classNames(styles.iconButton, className, {
    [styles.reversedIconOrder]: iconPosition === "end",
  });
  const content = (
    <>
      {Icon && <span className={styles.icon}>{<Icon />}</span>}
      <span className={styles.label}>{children}</span>
    </>
  );
  if (isLinkButton(rest)) {
    return (
      <LinkBehaviour {...rest} className={classes}>
        {content}
      </LinkBehaviour>
    );
  }
  return (
    <button type="button" className={classes} {...(isButtonElement(rest) ? rest : {})}>
      {content}
    </button>
  );
};
